import React, { useEffect, useState } from "react";

import Compressor from "compressorjs";

import { useMediaQuery } from "react-responsive";

import logo from "../Assets/Kabakoo.png";
import "./style.css";
import { handleDataStructure } from "../config/helpers";
import HeaderTicket from "./HeaderTicket";

const deleteFile = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="25"
    viewBox="0 0 22 25"
    fill="none"
  >
    <path
      d="M1 5.05882H21M7.25 1H14.75M8.5 18.5882V10.4706M13.5 18.5882V10.4706M15.375 24H6.625C5.24429 24 4.125 22.7885 4.125 21.2941L3.55425 6.46809C3.52466 5.69945 4.09239 5.05882 4.80317 5.05882H17.1968C17.9076 5.05882 18.4753 5.69945 18.4457 6.46809L17.875 21.2941C17.875 22.7885 16.7557 24 15.375 24Z"
      stroke="#513F59"
      strokeWidth="1.5"
      strokeLinecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
const addFile = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M10 1L10 19M19 10L1 10"
      stroke="#513F59"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
const changeFileIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="28"
    viewBox="0 0 24 28"
    fill="none"
  >
    <path
      d="M12 24.275C5.92487 24.275 1 19.6747 1 13.9999C1 10.4126 2.96801 7.25472 5.95054 5.41683M13.6665 3.84199C18.9508 4.59218 23 8.85434 23 13.9999C23 17.7016 20.9045 20.9461 17.761 22.7548M13.3756 6.44918L10.4588 3.72459L13.3756 1V6.44918ZM10.4576 21.5508L13.3745 24.2754L10.4576 27L10.4576 21.5508Z"
      stroke="#F2EFE9"
      strokeWidth="1.5"
      strokeLinecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

function Ticket({ componentDidMount }) {
  const [file, setFile] = useState({ name: "", type: "", size: "", blob: "" });
  const [fileBlob, setFileBlob] = useState("");
  const [text, setText] = useState("");
  const [hoverImage, setHoverImage] = useState(false);

  const isBigScreen = useMediaQuery({ query: "(min-width: 1181px)" });

  const handleSaveUserInformation = () => {
    const object = {
      file: {
        name: file.name,
        type: file.type,
        size: file.size,
        blob: file.blob,
      },
      text: text,
    };
    handleDataStructure("ticket.data", object);
    handleDataStructure("signin", "");
    componentDidMount(9);
  };
  const handleHover = () => {
    setHoverImage(true);
  };

  const handleHorsHover = () => {
    setHoverImage(false);
  };

  const handleFileChange = (event) => {
    const fileFromForm = event.target.files[0];
    setFile({
      name: fileFromForm.name,
      type: fileFromForm.type,
      size: fileFromForm.size,
    });

    if (fileFromForm) {
      new Compressor(fileFromForm, {
        quality: 0.6,
        success: (compressedResult) => {
          if (compressedResult.type.startsWith("image/")) {
            // ICI APPRES LA COMPRESSION, ON TRANSFORME LE FICHIER EN Blob
            const imageUrl = URL.createObjectURL(compressedResult);
            setFileBlob(imageUrl);
            setFile((prevState) => ({
              ...prevState,
              blob: imageUrl,
            }));
          } else {
            console.error("Le fichier sélectionné n'est pas une image valide.");
          }
        },
        error: (error) => {
          console.error("Erreur lors de la compression du fichier :", error);
        },
      });
    }
  };

  const handleContentChange = (event) => {
    setText(event.target.value);
  };

  const handleFileRemove = () => {
    if (fileBlob) {
      URL.revokeObjectURL(fileBlob);
      setFileBlob(null);
    }
  };

  const activeSeletedInput = () => {
    let selectedFile = document.getElementById("selectedFile");
    selectedFile.click();
  };

  return (
    <div>
      <div className="heading">
        <div className="logo">
          <div className="image">
            <img src={logo} alt="logo" />
          </div>
        </div>
        <HeaderTicket />
      </div>
      <div className="ticket-form" style={{ marginTop: "5px" }}>
        <div className="input-area">
          <textarea
            name=""
            id=""
            cols="30"
            rows="10"
            placeholder="Décris ton problème"
            onChange={handleContentChange}
          ></textarea>
          <input
            type="file"
            name="file"
            id="selectedFile"
            accept="image/*"
            hidden
            onChange={handleFileChange}
          />
          <div className="btn-and-file">
            <div className="content">
              {fileBlob && (
                <div
                  className="file-preview"
                  onMouseEnter={handleHover}
                  onMouseLeave={handleHorsHover}
                >
                  <div
                    className="hover-active"
                    style={
                      isBigScreen
                        ? { visibility: hoverImage ? "visible" : "hidden" }
                        : {}
                    }
                    onClick={activeSeletedInput}
                  >
                    {changeFileIcon}
                  </div>
                  <img
                    src={fileBlob}
                    alt="Image sélectionnée"
                    style={{ display: fileBlob ? "block" : "none" }}
                  />
                </div>
              )}
              <div className="btn-part">
                {fileBlob ? (
                  <span onClick={handleFileRemove}>{deleteFile}</span>
                ) : (
                  <span onClick={activeSeletedInput}>{addFile}</span>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {fileBlob || text ? (
        <div className="btn-continue" onClick={handleSaveUserInformation}>
          <button>Continuer</button>
        </div>
      ) : (
        <div className="btn-continue">
          <button disabled style={{ opacity: "0.3" }}>
            Continuer
          </button>
        </div>
      )}
    </div>
  );
}

export default Ticket;
